/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./whitelist.vue?vue&type=template&id=d3c6bbbc&scoped=true&"
import script from "./whitelist.vue?vue&type=script&lang=js&"
export * from "./whitelist.vue?vue&type=script&lang=js&"
import style0 from "./whitelist.vue?vue&type=style&index=0&id=d3c6bbbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c6bbbc",
  null
  
)

export default component.exports